export default function ComparisonSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Traditional Methods <span className="text-teal-600">Don't Work</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Selling a hoarder house through traditional channels creates more problems than it solves.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-close-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Traditional Real Estate Agent</h3>
            </div>
            
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Requires complete cleanup</strong> before listing - you pay for everything</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Demands extensive repairs</strong> to make property marketable</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Charges 5-6% commission</strong> on final sale price</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Takes 6-12 months</strong> from cleanup to closing</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Requires open houses</strong> and multiple showings</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>No guarantee of sale</strong> - deals often fall through</span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Buyer financing delays</strong> and inspection issues</span>
              </li>
            </ul>

            <div className="mt-6 p-4 bg-red-100 rounded-lg">
              <p className="text-sm text-gray-800">
                <strong>Total Cost:</strong> $30,000-$80,000+ in cleanup, repairs, commissions, and holding costs
              </p>
              <p className="text-sm text-gray-800 mt-2">
                <strong>Timeline:</strong> 6-12 months of stress and uncertainty
              </p>
            </div>
          </div>

          <div className="bg-green-50 border-2 border-green-200 rounded-xl p-8">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mr-4">
                <i className="ri-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Sell to TREX RE LLC</h3>
            </div>
            
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Zero cleanup required</strong> - leave everything as-is</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>No repairs needed</strong> - we buy in any condition</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>No commissions or fees</strong> - you keep the full offer amount</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Close in 7-14 days</strong> or on your timeline</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>No showings required</strong> - one quick walkthrough</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Guaranteed sale</strong> - we pay cash, no financing contingencies</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Simple process</strong> - we handle all paperwork and details</span>
              </li>
            </ul>

            <div className="mt-6 p-4 bg-green-100 rounded-lg">
              <p className="text-sm text-gray-800">
                <strong>Total Cost:</strong> $0 - we cover all cleanup and closing costs
              </p>
              <p className="text-sm text-gray-800 mt-2">
                <strong>Timeline:</strong> 7-14 days from offer to cash in hand
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-10 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">The Choice is Clear</h3>
          <p className="text-xl text-gray-700 mb-8 max-w-3xl mx-auto">
            Why spend months and tens of thousands of dollars trying to sell traditionally when you can sell to us quickly, easily, and with zero hassle?
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => {
                const form = document.getElementById('contact-form');
                if (form) form.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-teal-600 text-white text-lg font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Get Your Cash Offer
            </button>
            <a 
              href="tel:+1234567890"
              className="px-8 py-4 bg-gray-900 text-white text-lg font-semibold rounded-lg hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call Us Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
